var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,1.125a7.864,7.864,0,0,1,5.97,13,7.656,7.656,0,0,0-11.94,0A7.864,7.864,0,0,1,9,1.125Zm-5.172,13.8a6.534,6.534,0,0,1,10.344,0,7.831,7.831,0,0,1-10.344,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9,10.125A3.375,3.375,0,1,0,5.625,6.75,3.375,3.375,0,0,0,9,10.125ZM9,4.5A2.25,2.25,0,1,1,6.75,6.75,2.252,2.252,0,0,1,9,4.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile.97f86b76cfc2e6e41048f5fb97029a51.svg";